export default [
    {
        path: "ticket",
        permit: "overview.ticketDetail",
        menu: { title: "ticket.detail.title", i18n: true },
        component: () => import("./ticket")
    },
    {
        path: "imall",
        permit: "overview.chat",
        menu: { title: "data.imrecord.title", i18n: true },
        component: () => import("./imAll")
    }
];

export const dataImRecord = {
    path: "imrecord",
    permit: "analytics.sessionlog",
    menu: { title: "data.imrecord.session", i18n: true },
    component: () => import("@/views/data/imrecord")
};

export const ticketHotRecord = {
    path: "tickethot",
    permit: "analytics.tickethottopic",
    menu: { title: "data.ticket.hottitle", i18n: true },
    component: () => import("@/views/data/hot")
};

export const ticketSatisRecord = {
    path: "ticketSatis",
    permit: "analytics.ticketsatisf",
    menu: { title: "data.ticket.ticketSatisfaction", i18n: true },
    component: () => import("@/views/data/satisfact")
};

export const imHotRecord = {
    path: "imhot",
    permit: "analytics.chathottopic",
    menu: { title: "data.chat.hottitle", i18n: true },
    component: () => import("@/views/data/imHot")
};
